import React from "react";
import ViewBankTransactionsPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/ViewBankPage";
import { useLocation } from "react-router-dom";

const ViewBank = () => {
  const {state} = useLocation();
  const {item} = state||{};

  return(
    <ViewBankTransactionsPage item={item}/>
  )
}

export default ViewBank